import React from 'react';
import NumberFormat from 'react-number-format';

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
}

const NumberMaskInput = React.forwardRef<NumberFormat<any>, CustomProps>(
  (props, ref) => {
    const { onChange, ...other } = props;

    return (
      // @ts-ignore
      <NumberFormat
        type="text"
        thousandSeparator="."
        decimalSeparator=","
        isNumericString
        {...other}
        getInputRef={ref}
        onValueChange={values => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          });
        }}
      />
    );
  },
);

export default NumberMaskInput;
